'use es6';

import { isTimeSeriesReport } from 'reporting-data/report/configReportGetters';
import SalesQuotaViewEditor from 'reporting-enablement/components/reportEditors/SalesQuotaViewEditor';
import { isQuotaReport } from '../../utils/salesAnalyticsHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const GoalViewControl = ({
  updateContext,
  report
}) => /*#__PURE__*/_jsx(SalesQuotaViewEditor, {
  report: report,
  onChange: updatedReport => {
    updateContext({
      intraperiod: updatedReport.getIn(['displayParams', 'customWidget', 'options', 'intraperiod'])
    }, report);
  }
});
GoalViewControl.isUsableForReport = ({
  report
}) => isQuotaReport(report) && isTimeSeriesReport(report);
export default GoalViewControl;